import { RepeatOrderFormValues } from "./RepeatOrderDialog"

export const prepareInitialValues = (details?: Partial<RepeatOrderFormValues> | null): RepeatOrderFormValues => {
    return {
        repeatType: details?.repeatType ?? "day",
        repeatInterval: details?.repeatInterval ?? 1,
        startDate: details?.startDate ?? null,
        endType: details?.endType ?? "on",
        endDate: details?.endDate ?? null,
        repeatCount: details?.repeatCount ?? 2,
        weekDays: details?.weekDays ?? [],
    }
}

export function formatRecurrence(values: Partial<RepeatOrderFormValues>): string {
    const startDate = values.startDate ? values.startDate.toFormat("MMMM d, yyyy") : ""
    const repeatType = values.repeatType === "day" ? "day" : "week"
    const repeatInterval =
        values.repeatInterval && values.repeatInterval > 1 ? `${values.repeatInterval} ${repeatType}s` : `${repeatType}`
    const endDate = values.endDate ? `, ending on ${values.endDate.toFormat("MMMM d, yyyy")}` : ""
    const repeatCount = values.repeatCount ? `, ${values.repeatCount} times` : ""
    const days = values.weekDays && values.weekDays.length ? ` on ${values.weekDays.join(", ")}` : ""

    return `Occurs every ${repeatInterval}${days}, running from ${startDate}${repeatCount}${endDate}.`
}
